import {create} from "zustand";

export const useGlobalStore = create((set) => ({
  search: "",
  setSearch: (key) => set({ search: key }),
}));
